export default [
    {
        path: "/influencer/influencer/personal-info",
        name: "influencer-influencer-personal-info",
        meta: {
            title: "Personal Info", authRequired: true, subject: 'influencer',
            action: 'read',
        },
        component: () => import("../views/influencer/influencer/PersonalInfo")
    },
    {
        path: "/influencer/influencer/social-network",
        name: "influencer-influencer-social-network",
        meta: {
            title: "Social Networks", authRequired: true, subject: 'influencer',
            action: 'read',
        },
        component: () => import("../views/influencer/influencer/InfluencerSocialNetwork")
    },
    {
        path: "/influencer/influencer/influencer-services",
        name: "influencer-influencer-influencer-services",
        meta: {
            title: "Influencer services", authRequired: true, subject: 'influencer',
            action: 'read',
        },
        component: () => import("../views/influencer/influencer/InfluencerService")
    },
    {
        path: "/influencer/recruitment/list-recruitments",
        name: "influencer-recruitment-list-recruitments",
        meta: {
            title: "List Recruitments", authRequired: true, subject: 'influencer',
            action: 'read',
        },
        component: () => import("../views/influencer/recruitment/RecruitmenList")
    },
    {
        path: "/influencer/recruitment/recruitment-view/:id",
        name: "influencer-recruitment-recruitment-view",
        meta: {
            title: "Recruitment View", authRequired: true, subject: 'influencer',
            action: 'read',
        },
        component: () => import("../views/influencer/recruitment/RecruitmentView")
    },
    {
        path: "/recruiter/recruitment/recruitment-view/:id",
        name: "recruiter-recruitment-recruitment-view",
        meta: {
            title: "Recruitment View", authRequired: true, subject: 'influencer',
            action: 'read',
        },
        component: () => import("../views/influencer/recruitment/RecruitmentView")
    },
    {
        path: "/influencer/recruitment/apply-boards",
        name: "influencer-recruitment-apply-boards",
        meta: {
            title: "Recruitment View", authRequired: true, subject: 'influencer',
            action: 'read',
        },
        component: () => import("../views/influencer/recruitment/ApplyBoards")
    },

]